import common from 'locales/en/common.json';
import auth from 'locales/en/auth.json';
import admin from 'locales/en/pages/admin.json';
import navigation from 'locales/en/navigation.json';
import home from 'locales/en/pages/home.json';
import company from 'locales/en/pages/company.json';
import transactions from 'locales/en/pages/transactions.json';
import support from 'locales/en/pages/support.json';
import genericItem from 'locales/en/pages/genericItem.json';
import myClients from 'locales/en/pages/myClients.json';
import calendar from 'locales/en/pages/calendar.json';
import financialCenter from 'locales/en/financialCenter.json';
import forms from 'locales/en/forms.json';
import profile from 'locales/en/pages/profile.json';
import commissions from 'locales/en/pages/advisorReports.json';
import searchPage from 'locales/en/pages/search.json';
import downloadError from 'locales/en/downloadError.json';

export const resources = {
  common,
  auth,
  admin,
  navigation,
  home,
  company,
  transactions,
  support,
  genericItem,
  myClients,
  calendar,
  financialCenter,
  profile,
  forms,
  commissions,
  searchPage,
  downloadError,
} as const;
